<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentdata.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
  
    <div>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Cancellation notes</mat-label>
        <textarea
          [(ngModel)]="notes"
          matInput
        ></textarea>
        <mat-icon matSuffix class="material-icons-outlined">description</mat-icon>
      </mat-form-field>
    </div>

  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Do not cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !notes
      "
      (click)="onPost()"
    >
      Cancel now
    </button>
  </mat-dialog-actions>
  